/**
 * Utility functions for detecting external app context (HubSpot, Salesforce Canvas).
 */

/**
 * Checks if the application is running in HubSpot context
 * by checking if the current URL contains 'hubspot'
 *
 * @returns {boolean} True if running in HubSpot context, false otherwise
 */
export const isHubSpotContext = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  if (!window.location) {
    return false
  }

  return window.location.href.toLowerCase().includes('hubspot')
}

/**
 * True when the route is a Salesforce Canvas / external Salesforce app URL.
 * Use for UI layout (footers, alignment). For auth-gated API work, prefer
 * SalesforceContext `isInSalesforceContext` or canvas auth helpers.
 */
export const isSalesforceContextPath = (pathname: string): boolean => {
  const normalized = pathname.toLowerCase()
  return (
    normalized.includes('/external-apps/salesforce') ||
    normalized.includes('/salesforce/')
  )
}

/** {@link isSalesforceContextPath} for the current browser location. */
export const isSalesforceContext = (): boolean => {
  if (typeof window === 'undefined' || !window.location) {
    return false
  }

  return isSalesforceContextPath(window.location.pathname)
}
